<div class="grid m-0 p-0">
  <div class="col-12 m-0 p-0">
    <!-- [(value)]="messages" -->
    <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
  </div>
  <ng-container card-body>
    <div *ngIf="(isLoading$ | async)" class="w-full flex align-items-center justify-content-center">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
  </ng-container>
  <div *ngIf="!(isLoading$ | async)" class="col-12 m-0 p-0 mb-4">
    <div class="grid m-0 p-0">
      <div class="col-12 border-round-top-md mt-4 bg-gray">
        <div class="font-bold text-xs ml-6 flex align-items-center tipo-style"
          >Tipo</div>
      </div>
      <!-- accordion -->
      <p-accordion class="m-0 p-0 w-full">
        <ng-container *ngIf="listaTypeExpense$ | async as listaTypeExpense">
          <div class="border-gray" *ngFor="let item of listaTypeExpense">
            <p-accordionTab>
              <ng-template pTemplate="header">
                <span
                  class="flex align-items-center gap-2 w-full border-top-gray"
                >
                  <span class="font-bold white-space-nowrap orange-text">{{
                    item.name
                  }}</span>
                  <div class="ml-auto mr-4">
                    <div class="col-12 m-0 p-0 my-2 text-right">
                      <p-button

                        (onClick)="$event.stopPropagation(); showForm(item)"
                        class="ml-4 "
                        label="Adicionar"
                      ></p-button>
                    </div>
                  </div>
                </span>
              </ng-template>

              <ng-container *ngIf="listaExpense$ | async as listaExpense">
                <span style="height: 42px;" *ngFor="let expense of listaExpense | filterById : item['@id']" class="flex align-items-center gap-2 w-full border-top-gray mb-3">
                  <span
                  [ngClass]="{'inactive' : !expense.isActive}"
                  class="ml-5  gray-text"
                    >                  {{ expense.name }}</span
                  >
                  <div class="ml-auto mr-4">
                    <p-button
                    [ngClass]="{'inactive' : !expense.isActive}"
                      [rounded]="true"
                      [text]="true"
                      severity="secondary"
                      *ngIf="!expense.isGlobal"
                      (onClick)="$event.stopPropagation(); editCard(expense, item['@id'])" pTooltip="Editar"
                    >
                      <ng-template pTemplate="icon">
                        <div class="flex">
                          <split-icon size="small" name="edit" size="20"></split-icon>
                        </div>
                      </ng-template>
                    </p-button>
                    <p-button
                      *ngIf="expense.expenseType != '/api/expense_types/1' && !expense.isGlobal"
                      class="ml-4"
                      [rounded]="true"
                      [text]="true"
                      severity="danger"
                      (onClick)="$event.stopPropagation(); deleteCard(expense.id)" pTooltip="Deletar"
                    >
                      <ng-template pTemplate="icon">
                        <div class="flex">
                          <split-icon size="small" name="trash"></split-icon>
                        </div>
                      </ng-template>
                    </p-button>

                    <ng-template [ngIf]="expense.isActive && !expense.isGlobal">

                      <p-button
                      *ngIf="expense.expenseType == '/api/expense_types/1'"
                      class="ml-4"
                      [rounded]="true"
                      [text]="true"
                      severity="danger"
                      (onClick)="$event.stopPropagation(); inactiveExpense(expense)" pTooltip="Inativar Depesa"
                    >
                      <ng-template pTemplate="icon">
                        <div class="flex">
                          <img src="assets/lista-unidade/inativar.svg" alt="" />
                        </div>
                      </ng-template>
                    </p-button>

                  </ng-template>
                  <ng-template [ngIf]="!expense.isActive && !expense.isGlobal">

                    <p-button
                      *ngIf="expense.expenseType == '/api/expense_types/1'"
                      class="ml-4"
                      [rounded]="true"
                      [text]="true"
                      severity="danger"
                      (onClick)="$event.stopPropagation(); activeExpense(expense)" pTooltip="Ativar Depesa"
                    >
                      <ng-template pTemplate="icon">
                        <div class="flex">
                          <img src="assets/cadastro/active.svg" alt="ativar Depesa" />

                        </div>
                      </ng-template>
                    </p-button>
                  </ng-template>


                  </div>
                </span>
              </ng-container>
            </p-accordionTab>

          </div>
        </ng-container>
      </p-accordion>
    </div>
  </div>
</div>



<p-dialog [(visible)]="mostrarModalDeletar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div class="content">
    <img src="assets/lista-unidade/modal-deletar/deletar-unidade.svg" alt="imagem deletar unidade" />
    <span class="title">
      <p>Tem certeza que deseja deletar</p>
      <p>essa Despesa?</p>
    </span>
    <span class="message">
      <p>Ao confirmar você excluirá permanentemente</p>
      <p>a despesa selecionada</p>
    </span>
  </div>
  <ng-template pTemplate="footer">
    <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
    <button class="deletar" (click)="deleteCardDelete()">Deletar</button>
  </ng-template>
</p-dialog>


<p-dialog [(visible)]="mostrarModalInativar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="imagem deletar">
        <span class="title">
            <p>Tem certeza que deseja inativar</p>
            <p>essa Despesa?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você inativará essa despesa da sua listagem</p>
            <p>padrão.</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="inativar" (click)="patchIsActiveExpense()">Inativar</button>
    </ng-template>

</p-dialog>

<p-dialog [(visible)]="mostrarModalAtivar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/cadastro/active_modal.svg" alt="imagem deletar unidade">
        <span class="title">
            <p>Tem certeza que deseja ativar</p>
            <p>essa Despesa?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você irá ativar essa despesa na sua listagem</p>
            <p>padrão</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="ativar" (click)="patchIsActiveExpense()">Ativar</button>
    </ng-template>

</p-dialog>